import { Button, Tooltip } from "antd";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import Api from "../api";
import { showError } from "../utils";

type Props = {
  userId: number;
};

export const ReferralCodeDisplay = ({ userId }: Props) => {
  const [code, setCode] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchReferralCode = async () => {
      try {
        const { referral_code } = await Api.get(
          `/api/users/${userId}/referral_code`
        );
        setCode(referral_code);
      } catch (error) {
        console.error("failed to get referral code" + error);
      }
    };
    fetchReferralCode();
  }, [userId]);

  const handleCopy = async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      showError("Failed to copy referral code", error);
    }
  };

  if (!code) return <span style={{ color: "#6b7fa8" }}>Loading…</span>;

  return (
    <div className="referral-code-display">
      <code>{code}</code>
      <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
        <Button
          icon={copied ? <CheckOutlined /> : <CopyOutlined />}
          onClick={handleCopy}
        >
          {copied ? "Copied" : "Copy"}
        </Button>
      </Tooltip>
    </div>
  );
};
